import { DATE_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import { OrganizationActivityColumn } from "@common/types/views/organizationActivityView";
import { ViewConfig } from "@lib/views";
import { OrganizationActivityRow } from "./organizationActivityRow";
import { ActorCell } from "./cells/ActorCell";
import { ActionCell } from "./cells/ActionCell";
import { CreatedAtCell } from "./cells/CreatedAtCell";
import { ClientsCell } from "./cells/ClientsCell";
import { OrganizationActionsCell } from "./cells/OrganizationActionsCell";

export const organizationActivityViewConfig: ViewConfig<
    OrganizationActivityRow,
    OrganizationActivityColumn,
    never
> = {
    columns: {
        [OrganizationActivityColumn.CREATED_AT]: {
            accessorKey: "date",
            name: "Date",
            header: "",
            cell: CreatedAtCell,
            immutable: true,
            ...DATE_COLUMN_SIZE,
        },
        [OrganizationActivityColumn.ACTOR]: {
            accessorKey: "actorId",
            name: "Updated by",
            header: "Updated by",
            cell: ActorCell,
            minSize: 150,
            maxSize: 200,
        },
        [OrganizationActivityColumn.ACTION]: {
            accessorKey: "changeTypes",
            name: "Activity",
            header: "Activity",
            cell: ActionCell,
            minSize: 300,
            maxSize: 800,
        },
        [OrganizationActivityColumn.CLIENTS]: {
            accessorKey: "clientWorkspaceIds",
            name: "Clients",
            header: "Clients",
            cell: ClientsCell,
            minSize: 100,
            maxSize: 100,
        },
        [OrganizationActivityColumn.ACTIONS]: {
            accessorKey: "id",
            name: "",
            header: "",
            cell: OrganizationActionsCell,
            minSize: 220,
            maxSize: 260,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
